import { render, staticRenderFns } from "./StepFarmerGoals.vue?vue&type=template&id=ee7a4274&scoped=true&"
import script from "./StepFarmerGoals.vue?vue&type=script&lang=js&"
export * from "./StepFarmerGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7a4274",
  null
  
)

export default component.exports